namespace $.$$ {

	// class Button_open extends $mol_button_open {
	// 	sub() {
	// 		return [
	// 			this.Icon(),
	// 			this.title(),
	// 			this.Native(),
	// 		]
	// 	}
	// }

	export class $shm_hitalama_map_catalog extends $.$shm_hitalama_map_catalog {

		// @ $mol_memo.field
		// get $() {
		// 	return super.$.$mol_ambient({
		// 		$mol_button_open: Button_open,
		// 	})
		// }

		@ $mol_mem_key
		Page( id: any ) {
			return this.Book(id) as any
		}

		maps_list_visible( next?: boolean ): boolean {
			return this.$.$mol_state_local.value(this+'.maps_list_visible', next) ?? true
		}

		@ $mol_action
		close_maps_list() {
			this.maps_list_visible( false )
		}

		@ $mol_mem
		pages(): readonly any[] {
			if( this.maps_list_visible() ) return super.pages()

			try {
				return this.spread_pages_deep()
			} catch (error) {
				return [ $mol_promise_like(error) ? 'Loading...' : String( error ) ]
			}
		}

		profile() {
			return $shm_hitalama_profile.current()
		}

		@ $mol_mem
		list() {
			return this.profile()?.Maps_list(null)!
		}

		@ $mol_mem
		entities() {
			const list = this.list().remote_list() as $shm_hitalama_map[]
			return list
		}

		@ $mol_mem_key
		map_props( id: string ) {
			const map = $giper_baza_glob.Pawn( new $giper_baza_link(id), $shm_hitalama_map )
			return {
				title: map.title(),
				changed_at: map.Changed_at()?.val()??0,
				created_at: map.Created_at()?.val()??0,
				access_level: map.access_level(),
			}
		}

		@ $mol_mem
		spread_ids_filtered() {
			const ids = super.spread_ids_filtered()
			const sorted = this.sort_by() == 'title' 
				? ids.toSorted( $mol_compare_text( ((id: string) => this.map_props( id ).title ) ) )
				: this.sort_by() == 'changed'
					? ids.toSorted( (a,b) =>
						this.map_props( a ).changed_at - this.map_props( b ).changed_at 
					)
					: ids.toSorted( (a,b) =>
						this.map_props( a ).created_at - this.map_props( b ).created_at 
					)

			const ordered = this.sort_order() == 'asc' ? sorted : sorted.toReversed()
			const favorites = new Set( this.map_favorite_ids() )
			return [
				... ordered.filter( id => favorites.has( id ) ),
				... ordered.filter( id => !favorites.has( id ) ),
			]
		}

		map_menu_links() {
			return super.menu_links()
		}

		@ $mol_mem_key
		public_icon_visible( id: string ) {
			return ['public_edit', 'public_read'].includes(this.map_props( id ).access_level)
				? super.public_icon_visible(id) : []
		}

		map_favorite_store_key() {
			return 'map_favorite_ids'
		}

		@ $mol_mem
		map_favorite_ids( next?: readonly string[] ): string[] {
			const profile = this.profile()
			if( !profile ) return [] as string[]
			if( next !== undefined ) {
				profile.store( this.map_favorite_store_key(), Object.fromEntries(
					next.map( id => [ id, true ] )
				) )
				return [ ... next ]
			}

			const ids = profile.store( this.map_favorite_store_key() )
			if( Array.isArray( ids ) ) {
				return ids.filter( id => typeof id === 'string' )
			}

			return ids && typeof ids === 'object'
				? Object.keys( ids ).filter( id => ids[ id ] )
				: [] as string[]
		}

		@ $mol_mem_key
		map_favorite( id: string, next?: boolean ) {
			const ids = this.map_favorite_ids()
			const exists = ids.includes( id )
			if( next === undefined ) return exists

			const next_ids = next
				? exists ? ids : [ ... ids, id ]
				: ids.filter( ( item: string ) => item !== id )
			this.map_favorite_ids( next_ids )
			return next
		}

		favorite_hint( id: string ) {
			return this.map_favorite( id ) ? 'Убрать из избранного' : 'Добавить в избранное'
		}

		@ $mol_action
		favorite_toggle( id: string, event?: Event | null ) {
			event?.preventDefault()
			event?.stopPropagation()
			this.map_favorite( id, !this.map_favorite( id ) )
			return event ?? null
		}

		@ $mol_mem_key
		editor_mode_link( id: string ) {
			return { ... this.menu_link_arg( id ), edit_mode: '' }
		}

		editor_mode_current( id: string ) {
			return this.spread() === id && this.$.$mol_state_arg.value( 'edit_mode' ) === ''
		}

		add_map( access_level: keyof ReturnType<typeof $shm_hitalama_map.access_level_to_ranks> ) {
			const titles = this.list()?.remote_list().map( ( m: $shm_hitalama_map ) => m.title() ) ?? []
			const title = $shm_hitalama_inc_name( titles, this.title_default() )

			const map = $shm_hitalama_map.make_new( title, access_level )!
			this.list().add( map.link() )
			this.$.$mol_state_arg.dict({
				... this.$.$mol_state_arg.dict(),
				shift_x: null,
				shift_y: null,
				zoom: null,
			})
			this.spread( map.link().toString() )
			return map
		}

		// commented for make it unchangeable
		// @ $mol_mem
		// sort_order( next?: string ): string {
		// 	return this.profile()?.Maps_sort_order(next)?.val(next) ?? 'asc'
		// }

		@ $mol_mem
		sort_by( next?: string ): string {
			return this.profile()?.Maps_sort_by(next)?.val(next) ?? 'created'
		}

		@ $mol_action
		add() {
			return this.add_map( 'private' )
		}

		@ $shm_hitalama_process_wire_action
		import( files: File[] ) {
			const json = $mol_wire_sync(this.$).$mol_blob_json( files[0] )
			const map = this.add()
			map.deserialize( json )
		}

	}

}
